import RewardValue from './RewardValue'

// Pure render — each row carries its own rewardType (per-position, from ROOT).
// The top-3 gold/silver/bronze border is plain CSS `:nth-child` on the row
// container (matches defenderV2 exactly — it's DOM-position based, not tied
// to the `position` field's value, which may be a rank range like "4-10").
const PrizeRow = ({ data }) => (
  <div className="standard-normal-prize-row-outer-container">
    <div className="standard-normal-prize-row-position">{data?.position}</div>
    <div className="standard-normal-prize-row-reward">
      <RewardValue rewardType={data?.rewardType} amount={data?.reward} />
    </div>
  </div>
)

export default PrizeRow
